import { render, staticRenderFns } from "./order_link.vue?vue&type=template&id=9d5b764e&scoped=true"
import script from "./order_link.vue?vue&type=script&lang=js"
export * from "./order_link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5b764e",
  null
  
)

export default component.exports